<template>
  <div>
    <el-dialog
      ref="downloadDeclarationFormDialog"
      v-dialogDrag
      title="下载委外服务项目零星宣传物料制作申报审批表"
      class="abow_dialog h600_dialog"
      width="1000px"
      :visible.sync="dialogVisible"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogDownloadForm"
        :model="dialogDownloadForm"
        :rules="dialogDownloadFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            申报条件信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="活动省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogDownloadForm.provinceId"
                    placeholder="请选择活动省区"
                    clearable
                    style="width:100%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceDataList"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="年度"
                  prop="year"
                >
                  <el-select
                    v-model="dialogDownloadForm.year"
                    placeholder="请选择年度"
                    clearable
                    style="width:100%"
                    @change="handleYearChange"
                  >
                    <el-option
                      v-for="item in yearOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="申请日期"
                  prop="applyDate"
                >
                  <el-date-picker
                    v-model="dialogDownloadForm.applyDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="合同"
                  prop="contractId"
                >
                  <el-select
                    v-model="dialogDownloadForm.contractId"
                    filterable
                    clearable
                    placeholder="请选择合同"
                    style="width:100%"
                    @change="handleContractChange"
                  >
                    <el-option
                      v-for="item in contractDataList"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; padding-left: 10px; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="合同项目"
                  prop="itemIdArray"
                >
                  <!-- <div>
                    <el-checkbox
                      v-model="checkAll"
                      :indeterminate="isIndeterminate"
                      style="margin-bottom: 12px;"
                      @change="handleCheckAllChange"
                    >
                      全选
                    </el-checkbox>
                  </div> -->
                  <el-row :gutter="10">
                    <el-checkbox-group
                      v-model="dialogDownloadForm.itemIdArray"
                      @change="handleCheckedItemChange"
                    >
                      <el-col
                        v-for="(item) in contractItemDataList"
                        :key="'ContractServiceItem_' + item.id"
                        :span="6"
                      >
                        <el-checkbox
                          :label="item.id"
                          style="width: 100%;"
                        >
                          {{ item.name }}
                        </el-checkbox>
                      </el-col>
                    </el-checkbox-group>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          plain
          @click="handleDownload"
        >
          下载
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 区域API
import { listAreaApi } from '@/api/v2/area';
// 合同API
import { listContractApi } from '@/api/v2/contract';
// 合同项目API
import { listContractServiceItemApi } from '@/api/v2/contractServiceItem';
// 资料文档下载API
import { downloadMaterialsMakeDeclarationApi } from '@/api/v2/dataTemplate';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      provinceDataList: [],
      yearOptions: [],
      contractDataList: [],
      contractItemDataList: [],
      serviceItemIdArray: [],
      isIndeterminate: false,
      checkAll: false,
      dialogDownloadForm: {},
      dialogDownloadFormRules: {
        provinceId: [{ required: true, message: '请选择活动省区', trigger: 'change' }],
        year: [{ required: true, message: '请选择活动年度', trigger: 'change' }],
        contractId: [{ required: true, message: '请选择合同', trigger: 'change' }],
        applyDate: [{ required: true, message: '请选择申请日期', trigger: 'blur' }],
        itemIdArray: [{ required: true, message: '请选择合同服务项目', trigger: 'change' }],
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.contractDataList = [];
        _this.contractItemDataList = [];
        _this.yearOptions = [];
        _this.dialogDownloadForm = {
          provinceId: null,
          year: null,
          contractId: '',
          applyDate: '',
          itemIdArray: []
        };
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        for (let i = (currentYear - 2); i <= (currentYear + 1); i++) {
          _this.yearOptions.push({ label: i + '年', data: i })
        }
        _this.loadProvinceData();

        _this.$nextTick(() => {
          _this.$refs.dialogDownloadForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 获取省区数据
    loadProvinceData () {
      let _this = this;
      _this.provinceDataList = []
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceDataList.push({ label: item.name, data: item.id })
        })
      })
    },
    // 获取合同数据
    loadContractData (provinceId, year) {
      let _this = this;
      _this.contractDataList = [];
      listContractApi({ provinceId: provinceId, year: year }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.contractDataList.push({ label: item.name, data: item.id, code: item.code, name: item.name })
        })
      })
    },
    // 省区选项变更回调处理
    handleProvinceChange (val) {
      let _this = this;
      _this.contractDataList = [];
      _this.dialogDownloadForm.contractId = '';
      if (val && _this.dialogDownloadForm.year) {
        _this.loadContractData(val, _this.dialogDownloadForm.year);
      }
    },
    // 年度选项变更回调处理
    handleYearChange (val) {
      let _this = this;
      _this.contractDataList = [];
      _this.dialogDownloadForm.contractId = '';
      if (val && _this.dialogDownloadForm.provinceId) {
        _this.loadContractData(_this.dialogDownloadForm.provinceId, val);
      }
    },
    // 合同选项变更回调处理
    handleContractChange (val) {
      let _this = this;
      _this.dialogDownloadForm.itemIdArray = [];
      _this.contractItemDataList = [];
      _this.serviceItemIdArray = [];
      if (val) {
        listContractServiceItemApi({ contractId: val, type: 4 }).then((response) => {
          const { data } = response;
          _this.contractItemDataList = data || [];
          _this.contractItemDataList.forEach((item) => {
            _this.serviceItemIdArray.push(item.id);
          })
        }).catch(() => { })
      }
    },
    // 全选
    handleCheckAllChange (val) {
      let _this = this;
      _this.dialogDownloadForm.itemIdArray = val ? _this.serviceItemIdArray : [];
      _this.isIndeterminate = false;
    },
    // 合同项目选择变化回调
    handleCheckedItemChange (val) {
      let _this = this;
      let checkedCount = val.length;
      _this.checkAll = checkedCount === _this.serviceItemIdArray.length;
      _this.isIndeterminate = checkedCount > 0 && checkedCount < _this.serviceItemIdArray.length;
    },
    // 下载
    handleDownload () {
      let _this = this;
      _this.$refs.dialogDownloadForm.validate(valid => {
        if (valid) {
          downloadMaterialsMakeDeclarationApi(_this.dialogDownloadForm).then((response) => {
            const { data } = response
            _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
          }).catch(() => { })
        }
      })
    },
    modalClose () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox-group .el-col {
  min-height: 36px;
}
</style>
